export default {"src":"/_next/static/media/try-live-classes.81d7d531.svg","height":208,"width":234,"blurWidth":0,"blurHeight":0};